// extracted by mini-css-extract-plugin
export default {"deleteButton":"dmiYO"};